<template lang="pug">
v-container(fluid class=" tw-relative tw-max-w-full tw-w-full tw-max-h-full tw-px-0 tw-mx-0")
  v-row(class="tw-absolute tw-z-10 tw-w-full tw-m-0")
    v-col(cols="12" class="tw-w-full tw-p-0")
      v-autocomplete(
        autocomplete="empty"
        dense
        :loading="loading"
        :search-input.sync="contactsSearch"
        :allow-overflow="false"
        :menu-props="{ maxHeight: 250 }"
        hide-details="auto"
        outlined
        v-model="contact"
        :items="contacts"
        filled
        background-color="white"
        hide-no-data
        no-filter
        @change="selection(contact)"
        item-value="item"
        clearable
        :label="$t('Common.search')"
        class="p-0"
      )
        template(v-slot:selection="data")
          span(class="tw-capitalize") {{ data.item.name }} {{ data.item.last_name }}
        template(v-slot:item="data")
          template(v-if="typeof data.item !== 'object'")
            v-list-item-content(v-text="data.item")
          template(v-else)
            v-list-item-content
              v-list-item-title
                span(class=" tw-capitalize") {{ data.item.name }} {{ data.item.last_name }}
              v-list-item-subtitle
                span {{ data.item.email }}
</template>

<script>
export default {
  props: {
    entityType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      contacts: [],
      contact: {},
      contactsSearch: null,
    };
  },

  watch: {
    contactsSearch(searchString) {
      this.searchContacts(searchString);
    },
  },

  created() {
    this.searchContacts = _.debounce(function (searchString) {
      if (searchString && searchString.length > 1) {
        this.loading = true;
        return this.$store
          .dispatch('contacts/search', searchString)
          .then((response) => {
            this.loading = false;
            this.contacts = response;
          })
          .catch((error) => {
            this.loading = false;
          });
      }
    }, 900);
  },

  methods: {
    selection(item) {
      this.$store.commit(this.entityType + '/contacts/SET_CURRENT_CONTACT', item);
    },
  },
};
</script>
